import React from 'react';

const MapEmbed = () => {
  return (
    // <div className='map-container w-full aspect-video h-[40vh]'>
    //   <iframe
    //     src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d58264.616005605734!2d21.579591794633174!3d57.36129329493837!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46f1c9b5b1c4e8cf%3A0x96b9a0f95ffdbe2b!2sNotone!5e1!3m2!1sen!2slv!4v1740095178642!5m2!1sen!2slv'
    //     className='w-full h-[40vh]'
    //     style={{ border: 0 }}
    //     allowFullScreen
    //     loading='lazy'
    //     referrerPolicy='no-referrer-when-downgrade'
    //     title='Google Maps Embed'
    //   ></iframe>
    // </div>
    <div></div>
  );
};

export default MapEmbed;